import LegalLayout, { Section } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout eyebrow="Legal" title="Terms of Service" version="v1.0" effective="February 14, 2026">
      <div
        className="border border-volt/40 bg-volt/5 p-4 text-volt text-sm leading-relaxed"
        data-testid="terms-placeholder-notice"
      >
        These Terms are placeholder terms and should be reviewed by a qualified lawyer before launch.
      </div>

      <Section heading="1. Introduction" testid="terms-introduction">
        <p>
          PITCHD is a technology platform that helps athletes, sports creators, brands, agents, and managers
          manage sponsorship workflows, commercial opportunities, outreach, media kits, and related
          activities.
        </p>
      </Section>

      <Section heading="2. Platform Role" testid="terms-platform-role">
        <p>
          PITCHD is a software and technology platform. PITCHD is not acting as a sports agent, talent agent,
          legal representative, financial adviser, employment intermediary, or exclusive representative
          unless separately agreed in writing.
        </p>
      </Section>

      <Section heading="3. No Guarantee of Outcomes" testid="terms-no-guarantee">
        <p>
          PITCHD does not guarantee sponsorship opportunities, brand deals, revenue, commercial results,
          audience growth, or partnership success.
        </p>
      </Section>

      <Section heading="4. User Responsibilities" testid="terms-user-responsibilities">
        <p>
          Users are responsible for the accuracy of profile information, sponsorship data, brand
          communications, and any content they send externally.
        </p>
      </Section>

      <Section heading="5. AI Generated Content" testid="terms-ai-content">
        <p>
          PITCHD may provide AI-generated content, including outreach messages, bios, campaign ideas,
          sponsorship pitches, and media kit content. Users are responsible for reviewing, editing, and
          approving all AI-generated content before using it.
        </p>
      </Section>

      <Section heading="6. Subscriptions and Payments" testid="terms-subscriptions">
        <p>
          Paid plans may renew automatically unless cancelled before the next billing date. Pricing, billing
          cycles, usage limits, and cancellation rights will be shown before purchase.
        </p>
      </Section>

      <Section heading="7. Commercial Opportunities" testid="terms-commercial-opportunities">
        <p>
          Commercial opportunities, introductions, leads, campaigns, or partnerships facilitated through
          PITCHD may be subject to platform fees, commissions, or commercial terms.
        </p>
      </Section>

      <Section heading="8. Anti-Circumvention" testid="terms-anti-circumvention">
        <p>
          Users agree not to intentionally bypass PITCHD to avoid applicable platform fees relating to
          opportunities, introductions, or commercial relationships originated through the platform.
        </p>
      </Section>

      <Section heading="9. Intellectual Property" testid="terms-ip">
        <p>
          PITCHD owns the platform, software, branding, interface, workflows, and proprietary systems. Users
          retain ownership of their own profile information and uploaded content.
        </p>
      </Section>

      <Section heading="10. Acceptable Use" testid="terms-acceptable-use">
        <p>
          Users must not misuse the platform, upload unlawful content, impersonate others, scrape the
          platform, spam brands or athletes, or use PITCHD for misleading commercial activity.
        </p>
      </Section>

      <Section heading="11. Limitation of Liability" testid="terms-liability">
        <p>
          PITCHD is not responsible for indirect losses, lost profits, failed sponsorships, missed
          opportunities, reputational harm, or commercial disputes between users and third parties.
        </p>
      </Section>

      <Section heading="12. Account Suspension" testid="terms-account-suspension">
        <p>
          PITCHD may suspend or terminate accounts that breach the Terms, misuse the platform, or create
          legal, commercial, or reputational risk.
        </p>
      </Section>

      <Section heading="13. Changes to Terms" testid="terms-changes">
        <p>
          PITCHD may update the Terms from time to time. Users may be required to accept updated Terms before
          continuing to use the platform.
        </p>
      </Section>

      <Section heading="14. Contact" testid="terms-contact">
        <p>
          For any questions about these Terms, contact{" "}
          <a className="text-volt" href="mailto:legal@pitchdhq.com">legal@pitchdhq.com</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
